import React from 'react'
import styles from './PopupDepositPlaced.module.scss'
import { Modal } from 'components/Modal/Modal'
import { Icon } from 'components/Icon/Icon'
import { Button } from 'components/Button/Button'
import { CopyLink } from 'components/CopyLink/CopyLink'

type Props = {
    onClose: () => void;
}

export function PopupDepositPlaced(props: Props) {
    // test data link
    const url = 'https://test-link.com'


    function onSubmit(event: React.FormEvent<HTMLFormElement>) {
        event.preventDefault()
    }

    return (
        <Modal onClose={props.onClose}>
            <form className={styles['wrapper']} onSubmit={onSubmit}>
                <div className={styles['saving']}>
                    <Icon name='patrons' />
                </div>
                <div>
                    <div className={styles['content']}>
                        <span className={styles['title']}>Deposit placed, copy the link</span>
                        <span className={styles['description']}>Here is your deposit link. Send it to recepient.</span>
                        <CopyLink link={url} />
                    </div>
                </div>
                <div className={styles['button']}>
                    <Button size='l' type='dark' onClick={() => { }}>
                        Complete
                    </Button>
                </div>
            </form>
        </Modal>
    )
}

